module.exports = __webpack_public_path__ + "img/solar-icon.e1dc6abb.svg";